export default __webpack_public_path__ + "static/media/dimo-stack1.webp";